
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 750 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.7 64.2c18.3-18.3 48-18.3 66.3 0L375 359 670 64.2c18.3-18.3 48-18.3 66.3 0 18.3 18.3 18.3 48 0 66.3L408.1 458.3c-18.3 18.3-48 18.3-66.3 0L13.7 130.4c-18.3-18.3-18.3-47.9 0-66.2z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#04092a"}})])
          )
        }
      }
    